/**
 * Resolves a currency symbol from a currency code or raw symbol string.
 * @param {string} [currencyCode] - ISO 4217 code (e.g. USD) or symbol string.
 * @param {string} [locale='en-US'] - Locale for Intl.NumberFormat.
 * @returns {string} Currency symbol, or '$' when missing/empty.
 */
export function resolveCurrencySymbol(currencyCode, locale = 'en-US') {
    if (!currencyCode) return '$';
    const trimmed = String(currencyCode).trim();
    if (!trimmed) return '$';
    if (trimmed.length === 3) {
        try {
            const parts = new Intl.NumberFormat(locale || 'en-US', {
                style: 'currency',
                currency: trimmed,
                currencyDisplay: 'symbol',
            }).formatToParts(0);
            const symbolPart = parts.find((part) => part.type === 'currency');
            return symbolPart?.value || trimmed;
        } catch (error) {
            return trimmed;
        }
    }
    return trimmed;
}
